/**
 * Multi-Device Provider Constants
 * Runtime constants separated from type definitions to ensure proper bundling
 * 
 * 🎯 Pure API Constants Only - No UI Constants
 */

import type { 
  MultiDeviceProviderConfig,
} from './types';

/**
 * Default configuration values
 */
export const DEFAULT_MULTI_DEVICE_CONFIG: MultiDeviceProviderConfig = {
  maxDevices: 64,
  maxConnectionsPerDevice: 4,
  defaultQuality: 'medium',
  enableConnectionPooling: true,
  connectionTimeout: 30000,
  poolCleanupInterval: 60000,
  enableStatistics: true,
  statisticsInterval: 5000,
  enableVoiceCommSupport: true
};

